import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

const ProposalDetail = lazy(() => import('@/components/blockpot/governance/proposal-detail/ProposalDetail'))

type ProposalSearch = {
    id?: string
}

export const Route = createFileRoute('/governance/proposal')({
    component: ProposalDetailPage,
    validateSearch: (search: Record<string, unknown>): ProposalSearch => {
        return {
            id: typeof search.id === 'string' ? search.id : undefined,
        }
    },
})

function ProposalDetailPage() {
    return <ProposalDetail />
}